import Config from './global-config';
var logTryQuota = Config.get('logTryTimes');
function errorTrigger() {
    if (logTryQuota > 0) {
        logTryQuota--;
    }
}
function canSave() {
    return logTryQuota > 0;
}
function resetQuota() {
    logTryQuota = Config.get('logTryTimes');
}
export default {
    errorTrigger: errorTrigger,
    canSave: canSave,
    resetQuota: resetQuota
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/logan-web/build/log-manager.js
// module id = KRYa
// module chunks = 2